class CartUpsellRecommendations extends HTMLElement {
  constructor() {
    super();

    // Initialize properties with default values if no values are provided in the dataset
    this.productIds = JSON.parse(this.dataset.productIds) || [];
    this.intent = this.dataset.intent || "related";
    this.limit = this.dataset.limit || 4;
  }

  // When the element is added to the DOM, fetch recommendations for each product ID
  connectedCallback() {
    const handleIntersection = async (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      try {
        // Create URLs for fetching recommendations for each product ID
        const urls = this.productIds.map(
          (id) =>
            `/recommendations/products?product_id=${id}&limit=${this.limit}&intent=${this.intent}&section_id=upsell-recommendations`
        );

        // Fetch recommendations for each URL in parallel
        const responses = await Promise.all(urls.map((url) => fetch(url)));

        // For each response, extract the HTML for the recommendations and add them to the element
        for (let response of responses) {

          // Extract HTML from response
          const text = await response.text();
          const html = document.createElement("div");
          html.innerHTML = text;

          // Get all the upsell card elements from the HTML
          const recommendations = html.querySelectorAll("[data-upsell-card]");

          // Only add as many recommendations as needed to reach the limit
          if (this.querySelectorAll("[data-upsell-card]").length < this.limit) {
            const numRecommendationsToAdd = Math.min(
              this.limit - this.querySelectorAll("[data-upsell-card]").length,
              recommendations.length
            );
            const carousel = this.querySelector(".splide__list");
            const fragment = document.createDocumentFragment();

            for (let i = 0; i < numRecommendationsToAdd; i++) {
              // Create a new <li> element for each recommendation card
              const li = document.createElement("li");
              li.classList.add("splide__slide", "grid__item");
              li.appendChild(recommendations[i]);
              fragment.appendChild(li);
            }
            carousel.appendChild(fragment);
            const cartSlider = this.querySelector("carousel-component");
            cartSlider.initCarousel();
          }
        }

        // this code for truncate the product title if change the place of this code this code will not work
        function truncateText(element, maxLength) {
          if (element) {
            var text = element.textContent.trim();
            if (text.length > maxLength) {
              // Truncate the text and add ellipsis
              element.textContent = text.substring(0, maxLength) + "...";
            }
          } else {
            console.error("Element not found");
          }
        }
        // Select all elements with the specified class
        var productTitleElements = document.querySelectorAll(
          "cart-upsell-recommendations .product-card__title"
        );

        // Define the maximum length for the truncated text
        var maxLength = 30; // Adjust this value based on your preference

        // Iterate over each element and call the truncateText function
        for (var i = 0; i < productTitleElements.length; i++) {
          truncateText(productTitleElements[i], maxLength);
        }
        // truncate code eneded here

        if (this.querySelectorAll("[data-upsell-card]").length) {
          this.classList.add(
            "tw-border-t",
            "tw-border-solid",
            "tw-border-gray-300"
          );
          this.querySelector("h3")?.classList.remove("hidden");
        }
      } catch (error) {
        console.error(error);
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(this);
  }
}

customElements.define("cart-upsell-recommendations", CartUpsellRecommendations);
